import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { useCurrentRawSnapshotsQuery } from "@/features/experience-curation/queries/useRawSnapshotsQuery";
import { useHasCommercialFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";

export const useCurationDescription = defineStore("curation-content-description-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();
  const rawSnapshotsQuery = useCurrentRawSnapshotsQuery();

  const initialValue = computed(() => translationsQuery.data.value?.text1 ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = true;

  const rawDescription = computed(() => rawSnapshotsQuery.data.value?.rawSnapshot?.raw?.commercial?.description || "");
  const publishedRawDescription = computed(
    () => rawSnapshotsQuery.data.value?.publishedRawSnapshot?.raw?.commercial?.description || ""
  );
  const hasUnpublishedChange = useHasCommercialFieldChange("description");
  const showRawFields = computed(() => curationExperienceStore.showRawFields);
  const isReadonly = computed(() => curationExperienceStore.isReadonly);

  return {
    id: "description",
    model,
    isRequired,
    isReadonly,
    isFilled,
    hasChanges,
    hasUnpublishedChange,
    rawDescription,
    publishedRawDescription,
    showRawFields,
    reset,
  };
});
